<template>
  <div class="shoushi_project3_wrap">
    <headerBlack-view></headerBlack-view>
    <div class="introduce_wrap">
      <div class="introduce flex-layout">
        <div class="introduce_left">
          <div class="introduce_title flex-layout">
            <img src="@/assets/yunqiao/menu.png" />
            <div class="flex-column">
              <span>项目介绍</span>
              <img src="@/assets/yunqiao/introduce.png" />
            </div>
          </div>
          <div class="introduce_name">课堂行为 大数据分析</div>
          <div class="introduce_detail">
            依托互联网络技术，采集学校课堂教育教学过程中的行为数据，形成对应的课堂行为数据集群，
            并通过对数据集群的深度挖掘，为教师发展、学校发展提供精准的支持服务。
            同时输出对应数据证据链，对学生学习进行精准的定位和指导。
          </div>
        </div>
        <div class="introduce_right flex-layout">
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/behavior.png" />
            <span>课堂行为</span>
            <span>Classroom Behavior</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/clustering.png" />
            <span>数据集群</span>
            <span>Data Clustering</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/diagnosis.png" />
            <span>精准诊断</span>
            <span>Accurate Diagnosis</span>
          </div>
        </div>
      </div>
    </div>
    <div class="feature_wrap">
      <div class="feature_top flex-layout">
        <img src="@/assets/yunqiao/menu.png" />
        <div class="flex-column">
          <span>产品特点</span>
          <img src="@/assets/yunqiao/feature.png" />
        </div>
      </div>
      <div class="feature_bottom flex-align-between">
        <div class="feature_item">
          <div class="item_top">
            <img src="@/assets/yunqiao/feature5.png" />
          </div>
          <span>行为数据库采集</span>
          <p>通过采集课堂行为</p>
          <p>形成教学数据库集群</p>
        </div>
        <div class="feature_item">
          <div class="item_top">
            <img src="@/assets/yunqiao/feature6.png" />
          </div>
          <span>数据挖掘</span>
          <p>对教学行为数据进行探索</p>
          <p>进而优化教育、教学过程中</p>
          <p>行为产生的结果</p>
        </div>
        <div class="feature_item">
          <div class="item_top">
            <img src="@/assets/yunqiao/feature5.png" />
          </div>
          <span>精准支持</span>
          <p>基于行为数据链证据可以</p>
          <p>为学校发展、教师发展</p>
          <p>提供支持服务</p>
        </div>
      </div>
    </div>
    <div class="architecture_wrap">
      <div class="architecture">
        <div class="architecture_top flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>架构形式</span>
            <img src="@/assets/yunqiao/architecture.png" />
          </div>
        </div>
        <div class="architecture_bottom flex-column-center">
          <div class="item_title flex-align">
            <span>核心</span>
            <span>教学行为大数据</span>
            <span>教学研究</span>
            <span>数据挖掘</span>
          </div>
          <div class="item_line flex-align">
            <img src="@/assets/yunqiao/line.png" />
          </div>
          <div class="item_content flex-align">
            <div class="item_wrap flex-align-around">
              以教师发展、学校发展为核心，帮助教师丰富、改善、
              重构教学实践提供精准服务
            </div>
            <div class="item_wrap flex-align-around">
              以课堂教学行为起点，大数据为依托，对教学行为数据进行采集，
              形成行为数据集群
            </div>
            <div class="item_wrap flex-align-around">
              通过数据证据链指导教师、学校对教育研究提供佐证，
              使教师、学校在教育教学研究中做到有据可依。
            </div>
            <div class="item_wrap flex-align-around">
              依据教育行为数据集群深度挖掘教学行为，
              通过数据证据链对中小学课堂教学进行精准判断。
            </div>
          </div>
        </div>
      </div>
      <div class="win_wrap">
        <div class="win_top flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>合作共赢</span>
            <img src="@/assets/yunqiao/win2.png" />
          </div>
        </div>
        <div class="win_bottom flex-layout">
          <div class="win_left">
            <div>
              <span>课堂行为数据</span>
            </div>
          </div>
          <div class="win_right">
              <div class="right_top flex-layout">
                  <div class="jiaoyu">
                      <span>教育教学研究</span>
                  </div>
                  <div class="teacher">
                      <span>教师发展</span>
                  </div>
              </div>
              <div class="right_bottom flex-layout">
                  <div class="shuju">
                      <span>数据深度挖掘</span>
                  </div>
                  <div class="school">
                      <span>学校发展</span>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
@import "./less/shoushi_project3.less";
</style>